import { useState } from "react";
import { useDispatch } from "react-redux";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { updateVideo } from "../../features/video/videoSlice";

export default function LikeUnlike({ video }) {
	const dispatch = useDispatch();
	const {likes, unlikes, id } = video;
	const [like, setLike] = useState(likes)
	const [unlike, setUnlike] = useState(unlikes)

	const handleLike = () => {
		setLike(prev => prev + 1);
		dispatch(updateVideo({ id: id, data: { likes: like + 1 } }));
	};

	const handleDislike = () => {
		setUnlike(prev => prev + 1);
		dispatch(updateVideo({ id: id, data: { unlikes: unlike + 1 } }));
	};

	return (
		<div className="flex gap-10 w-48">
			<div className="flex gap-1" onClick={handleLike}>
				<div className="shrink-0">
					<img className="w-5 block" src={likeImage} alt="Like" />
				</div>
				<div className="text-sm leading-[1.7142857] text-slate-600">
					{like}
				</div>
			</div>
			<div className="flex gap-1" onClick={handleDislike}>
				<div className="shrink-0">
					<img className="w-5 block" src={unlikeImage} alt="Unlike" />
				</div>
				<div className="text-sm leading-[1.7142857] text-slate-600">
					{unlike}
				</div>
			</div>
		</div>
	);
}
